export default ({ request }) => ({
    opaGetOrderExpenseApi(code) {
        return request({
            url: '/factory/opa/order/expense/getByCode',
            method: 'GET',
            params: { code },
        })
    },
    opaGetShipmentExpenseApi(code) {
        return request({
            url: '/factory/opa/shipment/expense/getByCode',
            method: 'GET',
            params: { code },
        })
    },
    opaGetTcExpenseApi(code) {
        return request({
            url: '/factory/opa/tc/expense/getByCode',
            method: 'GET',
            params: { code },
        })
    },
    opaGetOrderDeductionApi(code) {
        return request({
            url: '/factory/opa/order/deduction/getByCode',
            method: 'GET',
            params: { code },
        })
    },
    opaGetFabricInspectionApi(code) {
        return request({
            url: '/factory/opa/fabric/inspection/getByCode',
            method: 'GET',
            params: { code },
        })
    },
    opaGetMaterialInspectionApi(code) {
        return request({
            url: '/factory/opa/material/inspection/getByCode',
            method: 'GET',
            params: { code },
        })
    }
})